var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-arrows"},[_c('base-svg',{staticClass:"slider-arrow-prev",attrs:{"name":"arrow_down"},on:{"click":_vm.prevSlide}}),_c('base-svg',{staticClass:"slider-arrow-next",attrs:{"name":"arrow_down"},on:{"click":_vm.nextSlide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }